var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrade(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1443 3.21967C15.4372 3.51256 15.4372 3.98744 15.1443 4.28033L6.06066 13.364H9.90685C10.3211 13.364 10.6569 13.6998 10.6569 14.114C10.6569 14.5282 10.3211 14.864 9.90685 14.864L4.25 14.864C4.05109 14.864 3.86032 14.785 3.71967 14.6443C3.57902 14.5037 3.5 14.3129 3.5 14.114L3.5 8.45713C3.5 8.04292 3.83579 7.70713 4.25 7.70713C4.66421 7.70713 5 8.04292 5 8.45713L5 12.3033L14.0836 3.21967C14.3765 2.92678 14.8514 2.92678 15.1443 3.21967Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.35571 21.6443C9.06282 21.3514 9.06282 20.8766 9.35571 20.5837L18.4393 11.5L14.5931 11.5C14.1789 11.5 13.8431 11.1642 13.8431 10.75C13.8431 10.3358 14.1789 10 14.5931 10L20.25 10C20.4489 10 20.6397 10.079 20.7803 10.2197C20.921 10.3603 21 10.5511 21 10.75V16.4069C21 16.8211 20.6642 17.1569 20.25 17.1569C19.8358 17.1569 19.5 16.8211 19.5 16.4069V12.5607L10.4164 21.6443C10.1235 21.9372 9.6486 21.9372 9.35571 21.6443Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrade);
export default __webpack_public_path__ + "static/media/trade.b72bd737788a5cf711cd2b589143f998.svg";
export { ForwardRef as ReactComponent };